const commonGetters = {
  getPagination: (state) => state.pagination,
  getPaginationActivity: (state) => state.paginationActivity,
  getPaginationGlobalActivity: (state) => state.paginationGlobalActivity
}

export { commonGetters }
